import React from "react";
import PropTypes from "prop-types";
import { Table } from "reactstrap";

const normalizeMonthCellData = (value) => {
    if (value && typeof value === "object") {
        return {
            display: value?.display ?? "",
            drillDownKey: value?.drillDownKey ?? null,
            isClickable: Boolean(value?.isClickable && value?.drillDownKey),
        };
    }

    return {
        display: value ?? "",
        drillDownKey: null,
        isClickable: false,
    };
};

const renderCellValue = (column, row, onMonthCellClick) => {
    const accessor = column?.accessor;
    const value = row?.[accessor];

    if (column?.isMonthValue) {
        const monthCell = normalizeMonthCellData(value);
        if (!monthCell.display) {
            return <span className="text-muted">—</span>;
        }

        if (monthCell.isClickable && typeof onMonthCellClick === "function") {
            return (
                <button
                    type="button"
                    className="status-columns-report-value"
                    onClick={() =>
                        onMonthCellClick({
                            drillDownKey: monthCell.drillDownKey,
                            userName: row?.userName,
                            statusLabel: row?.label,
                            monthLabel: column?.Header,
                            statusKey: row?.statusKey,
                            userId: row?.userId,
                        })
                    }
                >
                    {monthCell.display}
                </button>
            );
        }

        return <span className="status-columns-report-value">{monthCell.display}</span>;
    }

    if (value === null || value === undefined || value === "") {
        return <span className="text-muted">—</span>;
    }

    return <span>{value}</span>;
};

const SmePerformanceReportTable = ({ columns = [], data = [], onMonthCellClick }) => {
    const visibleColumns = Array.isArray(columns) ? columns : [];
    const rows = Array.isArray(data) ? data : [];

    return (
        <div className="table-responsive">
            <Table
                hover
                borderless
                className="align-middle mb-0 custom-table leads-added-report-table sme-performance-report-table"
            >
                <thead>
                    <tr>
                        {visibleColumns.map((column) => (
                            <th
                                key={column?.accessor}
                                className={`text-nowrap${
                                    column?.isMonthValue ? " text-center" : ""
                                }`}
                            >
                                {column?.Header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.length ? (
                        rows.map((row, rowIndex) => {
                            if (row?.isSectionGap) {
                                return (
                                    <tr
                                        key={row?.id ?? `sme-gap-${rowIndex}`}
                                        className="sme-performance-section-gap"
                                        aria-hidden="true"
                                    >
                                        <td colSpan={Math.max(visibleColumns.length, 1)} />
                                    </tr>
                                );
                            }

                            if (row?.isUserHeaderRow) {
                                return (
                                    <tr
                                        key={row?.id ?? `sme-user-${rowIndex}`}
                                        className="sme-performance-user-header-row"
                                    >
                                        <td colSpan={Math.max(visibleColumns.length, 1)}>
                                            <strong>{row?.label || ""}</strong>
                                        </td>
                                    </tr>
                                );
                            }

                            return (
                                <tr key={row?.id ?? `sme-row-${rowIndex}`}>
                                    {visibleColumns.map((column) => (
                                        <td
                                            key={`${rowIndex}-${column?.accessor}`}
                                            className={
                                                column?.isMonthValue ? "text-center" : ""
                                            }
                                        >
                                            {renderCellValue(column, row, onMonthCellClick)}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td
                                colSpan={Math.max(visibleColumns.length, 1)}
                                className="text-center text-muted py-4"
                            >
                                No records found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

SmePerformanceReportTable.propTypes = {
    columns: PropTypes.array,
    data: PropTypes.array,
    onMonthCellClick: PropTypes.func,
};

export default SmePerformanceReportTable;
